export const blogLb = {
  // Blog page
  blogHeroTitle: "SheCan Geschichten",
  blogHeroSubtitle: "Richteg Fraen. Richteg Kraaft. Richteg Geschichten.",
  latestArticles: "Lescht Artikelen",
  readMore: "Méi Liesen",
  byAuthor: "Vun",
  
  // Categories
  empowerment: "Empowerment",
  career: "Carrière",
  wellness: "Wuelbefannen",
  relationships: "Bezéiungen",
  personalGrowth: "Perséinlech Wuesstum",
  inspiration: "Inspiratioun",
  mothersWisdom: "Mamm hir Weesheet",
  grandmothersLetters: "Bréiwer vun Groussmammen"
};

export default blogLb;
